export default "__VITE_ASSET__BLCnuGAB__"